export enum OtherOptionValues {
  YES = 'yes',
  NO_RESUBMIT_FOR_REVIEW = 'No - Resubmit for review',
  NO_DOCUMENT_WILL_NOT_BE_EXECUTED = 'No - the document will not be executed',
}
